import {Component, inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {DatePipe} from '@angular/common';
import {MarkdownModule} from 'ngx-markdown';
import {PageHeaderComponent} from '../util/design/page-header/page-header.component';
import {VersionHistoryEntry, VersionHistoryService} from '../../services/version-history/version-history.service';

@Component({
  selector: 'app-whats-new',
  templateUrl: './whats-new.component.html',
  styleUrls: ['./whats-new.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    PageHeaderComponent,
    MarkdownModule,
    DatePipe
  ]
})
export class WhatsNewComponent implements OnInit {
  entries: VersionHistoryEntry[] = [];
  loading = true;
  private versionHistoryService = inject(VersionHistoryService);

  ngOnInit(): void {
    this.versionHistoryService.getEntries().subscribe({
      next: entries => {
        this.entries = entries;
        this.loading = false;
        if (entries.length > 0) {
          localStorage.setItem('lastSeenVersion', entries[0].version);
        }
      },
      error: () => {
        this.loading = false;
      }
    });
  }
}
